import React from "react";

export default function NavBar() {
  return (
    <nav className="fsa-nav d-flex flex-row justify-content-between align-items-center w-100 flex-wrap gap-2">
      <a href="/" className="fsa-nav-brand">
        Friends of St. Andrews
      </a>
      <div className="fsa-nav-links">
        <a className="fsa-nav-link" href="/">
          Home
        </a>
        <a className="fsa-nav-link" href="/news">
          News
        </a>
        <a className="fsa-nav-link" href="/join">
          Join
        </a>
        <a className="fsa-nav-link" href="/donations">
          Donations
        </a>
        <a className="fsa-nav-link" href="/events">
          Events
        </a>
        <a className="fsa-nav-link" href="/gallery">
          Gallery
        </a>
        <a className="fsa-nav-link" href="/about">
          About
        </a>
      </div>
    </nav>
  );
}
